import _get from 'lodash/get';

import { Google, GoogleTransformers, Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById, isVDP } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

/**
 * @summary Sends Pixall, Adobe and Google events for the safety recall card cta
 */
export async function inventoryRecallDetailsClick(metadata, option) {
    const {
        data = {},
        dataLayer = {},
        state,
    } = metadata;

    const { inventoryId, pixallData = {} } = data;
    const pageName = _get(dataLayer, 'page.pageName', '');
    const inheritPageData = !['vdp'].includes(pageName);
    const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
    const inventory = getInventoryOwnerById(state, inventoryId);
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);

    const eventResult = 'cta::safety-recall';
    const eventElement = `vdp_${data?.listingType.toLowerCase()}`;
    const eventData = {
        vehicle: { ...vehicleData },
    };

    Pixall.sendClickEvent({
        eventSource: 'recall',
        eventType: 'click',
        inventory,
        label: `saf_rcl-${pageId}`,
        pixallData: {
            ...pixallData,
            clickTypeToListingType: isVDP(dataLayer),
        },
    }, dataLayer, option);

    Google.sendClickEvent({
        eventElement,
        eventResult,
        eventData,
    }, option);

    return { cmp: 'cta::safety-recall', eventResult, eventElement };
}
